import axios from 'axios';

class tenantService {
  constructor() {
    this.API_URL = process.env.REACT_APP_API_URL_V;
    this.apiClient = axios.create({
      baseURL: this.API_URL,
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    });

    this.apiClient.interceptors.request.use(config => {
      //   const token = JSON.parse(localStorage.getItem('loginInfonetApp'))?.token || '';
      //   console.log(token)
      const token = localStorage.getItem("accesstoken");
      config.headers['x-auth-token'] = token;
      return config;
    }, error => {
      return Promise.reject(error);
    });
  }

  async gettenants(data) {
    const response = await this.apiClient.post('/client/list', data);
    return response.data.data;
  }
  async gettenantsbyuser(data) {
    const response = await this.apiClient.post('/client/listbyuser', data);
    return response.data.data;
  }
  async addtenant(tenant) {
    const response = await this.apiClient.post('/tenantcreate', tenant);
    return response.data.data;
  }

  async updatetenant(id, tenant) {
    const response = await this.apiClient.put(`/clientupdate/${id}`, tenant);
    return response.data;
  }

  async deletetenant(id) {
    const response = await this.apiClient.delete(`/clientdelete/${id}`);
    return response.data;
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new tenantService();
